"use client";

import { useContext } from "react";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";

type BannerPlaceholderProps = {
	minHeight?: string;
	mobileHeight?: string;
};

/** Reserves hero space before banner media resolves (prevents CLS). */
const BannerPlaceholder = ({
	minHeight = "86vh",
	mobileHeight,
}: BannerPlaceholderProps) => {
	const { isIpad } = useContext(screenSizeContext);

	return (
		<div
			className="banner relative w-full bg-[#0d223d]"
			style={{ minHeight: isIpad ? (mobileHeight ?? minHeight) : minHeight }}
			aria-hidden
		/>
	);
};

export default BannerPlaceholder;
